import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";

import marketingImg from "assets/img/mission_2.png";

const Mission = () => {
  const [containerStyle, setContainerStyle] = useState({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    color: 'white',
    padding: '100px',  // Default padding for larger screens
    backgroundImage: `url(${marketingImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  });

  const [textContainerStyle, setTextContainerStyle] = useState({
    background: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '10px',
    padding: '20px',
    maxWidth: '600px',  // Limit width for smaller screens
    margin: 'auto',  // Center the text container
    fontSize: '10px',  // Default font size for larger screens
  });

  useEffect(() => {
    const handleResize = () => {
      const tinyScreens = window.matchMedia('(max-width: 320px)').matches;
      const smallerScreens = window.matchMedia('(max-width: 375px)').matches;
      const smallScreens = window.matchMedia('(max-width: 768px)').matches;
      const laptopScreens = window.matchMedia('(max-width: 1366px)').matches;
      const desktop = window.matchMedia('(max-width: 1440px)').matches;
      const fourK = window.matchMedia('(max-width: 2560px)').matches;

      if (tinyScreens) {
        setContainerStyle(prevStyle => ({ ...prevStyle, padding: '20px' }));
        setTextContainerStyle(prevStyle => ({ ...prevStyle, fontSize: '10px' }));
      } else if (smallerScreens) {
        setContainerStyle(prevStyle => ({ ...prevStyle, padding: '20px' }));
        setTextContainerStyle(prevStyle => ({ ...prevStyle, fontSize: '10px' }));
      }else if (smallScreens) {
        setContainerStyle(prevStyle => ({ ...prevStyle, padding: '30px' }));
        setTextContainerStyle(prevStyle => ({ ...prevStyle, fontSize: '11px' }));
      } else if (laptopScreens) {
        setContainerStyle(prevStyle => ({ ...prevStyle, padding: '40px' }));
        setTextContainerStyle(prevStyle => ({ ...prevStyle, fontSize: '11.5px' }));
      } else if (desktop) {
        setContainerStyle(prevStyle => ({ ...prevStyle, padding: '70px' }));
        setTextContainerStyle(prevStyle => ({ ...prevStyle, fontSize: '12px' }));
      }
      else if (fourK) {
        setContainerStyle(prevStyle => ({ ...prevStyle, padding: '80px' }));
        setTextContainerStyle(prevStyle => ({ ...prevStyle, fontSize: '12px' }));
      }
      
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Initial check on component mount
    handleResize();

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty dependency array ensures the effect runs only once on mount

  return (
    <>
      <div className="main">
        <div className="section section-maglev-blue-light text-center" style={containerStyle}>
          <Container>
            <div style={textContainerStyle}>
            <h2 className="text-center title" style={{ color: "white", marginTop: '20px', marginBottom: '20px', fontWeight: 'bolder'}}>Our Mission</h2>
              <h3 style={{ color: "white", marginTop: '20px', marginBottom: '30px'}}>
              We are building a breakthrough electric propulsion platform that leverages magnetic levitation and enables safer, quieter, and faster aircraft for urban air transit and beyond. 
              <br/><br/>
              The MagLev HyperDrive&trade; is a magnetically levitated electric propulsion system for aircraft, applicable to multiple sizes, configurations, payload types, and use cases.
              </h3>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Mission;
